import { i18n } from '../plugins/vuetify';

export default (value) => {
    return Number(value).toLocaleString(i18n.locale);
};
